import React, { useEffect, useMemo, useState } from 'react';

import { PageHeader } from '../../shared/ui';
import ModalConfirm from '../../shared/ui/modal-confirm/ui/ModalConfirm';
import Filter from '../../shared/ui/filter/Filter';
import { getAdminTeam } from '../../shared/api/team.services';
import { matchesActiveStatus, matchesSearch, useListFilters } from '../../shared/lib/useListFilters';
import TeamList from '../../widgets/team-list/ui/TeamList';
import { useTeamFilters } from '../../widgets/team-list/config/filter';

const SEARCH_FIELDS = ['fullName', 'role', 'shortBio', 'slug'];

export default function TeamPage() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const teamFilters = useTeamFilters();
  const { query, get } = useListFilters();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const result = await getAdminTeam();
        setMembers(result?.items || []);
      } catch (error) {
        console.error('Помилка при завантаженні даних:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Учасників небагато — фільтруємо на місці.
  const status = get('status');
  const visibleMembers = useMemo(
    () =>
      members.filter(
        (member) =>
          matchesSearch(member, query, SEARCH_FIELDS) && matchesActiveStatus(member, status)
      ),
    [members, query, status]
  );

  return (
    <>
      <ModalConfirm title="Ви впевнені, що хочете видалити цього учасника?" />

      <PageHeader
        placeholder={'Пошук за імʼям або посадою'}
        createLink={'/team-rewrite/create'}
        filters={teamFilters}
      />
      <Filter fields={teamFilters} />

      <section className="section-admin">
        {loading ? (
          <p>Завантаження...</p>
        ) : (
          <TeamList
            data={{ items: visibleMembers, total: visibleMembers.length }}
            totalCount={members.length}
          />
        )}
      </section>
    </>
  );
}
